import * as React from 'react';

import { useTranslation } from '@crehana/i18n';

import type { FormView } from '../types';

export type TitleProps = {
  formView: FormView;
  isDark?: boolean;
};

const Title: React.FC<React.PropsWithChildren<TitleProps>> = ({
  formView,
  isDark,
}) => {
  const { t } = useTranslation();

  if (formView === 'register') {
    return (
      <React.Fragment>
        <h2 className={`font-h2 ${isDark ? 'text-white' : ''}`}>
          {t('JOIN_CREHANA', { defaultValue: 'Únete ya' })}
        </h2>
        <h3 className={`font-body3 text-center ${isDark ? 'text-white' : ''}`}>
          {t('LIVE_EXPERIENCE_CREHANA', {
            defaultValue: 'Empieza tu camino de aprendizaje',
          })}
        </h3>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <h2 className={`font-h2 ${isDark ? 'text-white' : ''} text-center`}>
        {t('WELCOME_TO_BACK', {
          defaultValue: 'Bienvenido de vuelta',
        })}
      </h2>
      <h3
        className={`font-body3 ${isDark ? 'text-white' : ''} text-center mb-24`}
      >
        {t('SIGN_UP_AND_LEARNING', {
          defaultValue: 'Que bueno verte otra vez :)',
        })}
      </h3>
    </React.Fragment>
  );
};

export default Title;
